import cls from 'classnames';

import { toolCategories, IToolData, ToolCategory, IToolCategory } from '../../../data/tools';

import { IResultsCategoryProps } from './types';
import useStyles from './styles';

const allCategories = toolCategories.filter((c) => c.value !== ToolCategory.All);

function getCategoryWithMostResults(items: IToolData[]): IToolCategory {
  const categoryMap = {};

  for (const item of items) {
    for (const category of item.categories) {
      const current: number = categoryMap[category] || 1;

      categoryMap[category] = current + 1;
    }
  }

  const max: { count: number; category?: ToolCategory } = { count: 0 };
  for (const [category, count] of Object.entries(categoryMap)) {
    if (count > max.count) {
      max.category = category as ToolCategory;
      max.count = count as number;
    }
  }

  return allCategories.find((c) => c.value === max.category);
}

function getCategoryBasedOnSearchText(searchText: string) {
  const words = searchText.split(' ').map((w) => new RegExp(w, 'gi'));

  for (const word of words) {
    const found = allCategories.find((category) => word.test(category.value));

    if (found) {
      return found;
    }
  }
  return null;
}

export default function ResultsCategory({ items, searchText, className }: IResultsCategoryProps) {
  const classes = useStyles();

  if (!searchText) {
    return null;
  }

  const category = getCategoryBasedOnSearchText(searchText) || getCategoryWithMostResults(items);

  return (
    <a className={cls(classes.resultsAllLink, className)} href={category.href}>
      <div className={classes.resultsAll}>
        <span>See all </span>
        <span className={classes.resultsAllCategory}>{category.name}</span>
      </div>
    </a>
  );
}
